import React from "react";
import SettingTable from "src/pages/setting";

export default function SettingPage() {
  return <SettingTable />;
}
